import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import GeneralLayout from './generalLayout';

export default {
  list: GeneralLayout,
  icon: LocalLibraryIcon,
};
